var classes = {
  "root": "m_3eebeb36",
  "label": "m_9e365f20"
};
export { classes as default };